import React from "react";
import './Home.css';
import HomeSearchbar from "../Components/HomeSearchbar";
import HomeLeft from "../Components/HomeLeft";
import CarsByMake from "../Components/CarsByMake";
import HomeBanner from "../Components/HomeBanner";
import Marquee from "../Components/Marquee";
import SearchCarsSection from "../Components/SearchCarsSection";
import SearchCarsHome from "../Components/SearchCarsHome";
import NewArrivals from "../Components/NewArrivals";
import DemandedArrivals from "../Components/DemandedArrivals";
import ThirdPartyStock from "../Components/ThirdPartyStock";
import SellingDiscount from "../Components/SellingDiscount";
import HomeRight from "../Components/HomeRight";
import ReviewCarousel from "../Components/ReviewCarousel";
import AnimateGlobe from "../Components/AnimateGlobe";
// import Instagram from "../Components/Instagram";


const Home = () => {
    
    return (
        <>
        <div className="container-fluid">
            <div className="row">
                <div className="col-2 leftcol">
                    {/* <CarsByMake /> */}
                    <HomeLeft />
                </div>
                <div className="col-8 wow fadeInUp">
                    {/* <HomeSearchbar /> */}
                    <Marquee />
                    <HomeBanner />
                    <SearchCarsSection />
                    <SearchCarsHome />
                    <NewArrivals />
                    <DemandedArrivals />
                </div>
                <div className="col-2 rightcol">
                    <HomeRight />
                </div>
            </div>
        </div>
        <div className="container-fluid d-none">
            <div className="row">
                <div className="col-2 leftcol">
                    <HomeLeft />
                </div>
                <div className="col-8 wow fadeInUp">
                    <SearchCarsHome />
                    <NewArrivals />
                    <DemandedArrivals />
                </div>
                <div className="col-2 rightcol">
                    <HomeRight />
                </div>
            </div>
        </div>
        <div className="container-fluid d-none">
            <div className="row">
                <div className="col-12 wow fadeInUp">
                    <ThirdPartyStock />
                </div>
            </div>
        </div>
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="carousel-bg">
                        <h2 className="carousel-heading text-center">WHY CHOOSE Saad Motors TRADING Thailand</h2>
                      <p style={{ 
    width: "900px", 
    textAlign: "center", 
    margin: "0 auto" 
}}>At Saad Motors Trading Thailand, we specialize in exporting high-quality vehicles directly from Thailand. With a strong focus on quality, transparency, and customer satisfaction, we deliver reliable automotive solutions to clients worldwide.</p>
                    </div>
                    <AnimateGlobe />
                    {/* <SellingDiscount /> */}
                </div>
            </div>
        </div>
        <div className="container-fluid wow fadeInUp d-none" data-wow-delay="0.4s">
            <div className="row">
                <div className="col-12">
                    <ReviewCarousel />
                </div>
            </div>
        </div>
        <div className="container-fluid wow fadeInUp" data-wow-delay="0.4s">
            <div className="row">
                <div className="col-12">
                    {/* <Instagram /> */}
                </div>
            </div>
        </div>
        </>
    );
};

export default Home;